export { default } from './InfoVideo';
